import React from "react";
import { Button } from "@mui/material";

import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";

export default function FilterButton(props: {
  onChange: () => void;
  selected: boolean;
  imageSrc: string;
  imageStyle: any;
}) {
  const { isSmallLayout } = useWindowDimensions();

  const theme = useTheme();

  return (
    <Button
      onClick={() => {
        props.onChange();
      }}
      style={{
        borderStyle: "solid",
        height: isSmallLayout ? 30 : 60,
        width: isSmallLayout ? 50 : 80,
        backgroundColor: theme.buttonBackgroundColor,
        borderColor: props.selected ? theme.selectedColor : "black",
        borderWidth: props.selected ? theme.selectedBorderWidth : 0.1,
      }}
    >
      {" "}
      <img src={props.imageSrc} style={props.imageStyle} alt="" />
    </Button>
  );
}
